import { defineMessages } from 'react-intl';

export const connectEosBannerMessages: ReturnType<typeof defineMessages> = defineMessages({
	undeclaredAdmin: {
		id: 'connect-module-core.modules.app.undeclaredAdmin',
		defaultMessage:
			'{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we’ll no longer support after December 2026. Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps.',
		description: 'Warning shown to site admins when a Connect app has no migration intent.',
	},
	undeclaredNonAdmin: {
		id: 'connect-module-core.modules.app.undeclaredNonAdmin',
		defaultMessage:
			'{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we’ll no longer support after December 2026. To explore your options, contact your site admin.',
		description: 'Warning shown to non-admins when a Connect app has no migration intent.',
	},
	noAdmin: {
		id: 'connect-module-core.modules.app.noAdmin',
		defaultMessage:
			'{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we’ll no longer support after December 2026; after that, the vendor <migrationGuide><strong>will discontinue supporting it as well</strong></migrationGuide>. Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps.',
		description: 'Warning shown to site admins when a Connect app vendor will not migrate.',
	},
	noNonAdmin: {
		id: 'connect-module-core.modules.app.noNonAdmin',
		defaultMessage:
			'{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we’ll no longer support after December 2026. To explore your options, contact your site admin.',
		description: 'Warning shown to non-admins when a Connect app vendor will not migrate.',
	},
	undecidedAdmin: {
		id: 'connect-module-core.modules.app.undecidedAdmin',
		defaultMessage:
			"{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we’ll no longer support after December 2026. <migrationGuide><strong>Learn more</strong></migrationGuide> about the vendor's plans to migrate app users (including you). Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps.",
		description:
			'Warning shown to site admins when a Connect app vendor is unsure about migrating.',
	},
	undecidedNonAdmin: {
		id: 'connect-module-core.modules.app.undecidedNonAdmin',
		defaultMessage:
			"{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we’ll no longer support after December 2026. <migrationGuide><strong>Learn more</strong></migrationGuide> about the vendor's plans to migrate app users (including you). To explore your options, contact your site admin.",
		description: 'Warning shown to non-admins when a Connect app vendor is unsure about migrating.',
	},
	yesAdmin: {
		id: 'connect-module-core.modules.app.yesAdmin',
		defaultMessage:
			'{hasAppName, select, true {This version of <strong>{appName}</strong>} other {This app}} is running on a platform we’ll no longer support after December 2026. The app developer is creating a new version; read about their <migrationGuide>migration plans for app users</migrationGuide>.',
		description: 'Warning shown to site admins when a Connect app vendor will migrate.',
	},
	yesNonAdmin: {
		id: 'connect-module-core.modules.app.yesNonAdmin',
		defaultMessage:
			'{hasAppName, select, true {This version of <strong>{appName}</strong>} other {This app}} is running on a platform we’ll no longer support after December 2026. The app developer is creating a new version; read about their <migrationGuide>migration plans for app users</migrationGuide>.',
		description: 'Warning shown to non-admins when a Connect app vendor will migrate.',
	},
	devCanaryMessage: {
		id: 'connect-module-core.eos.devCanaryMessage',
		defaultMessage:
			"You're seeing this message because your tenant is enrolled in the <developerCanaryProgram>Developer Canary Program</developerCanaryProgram>. For updates on when this goes live in production, watch the <forgeChangelog>Forge changelog</forgeChangelog>.",
		description:
			'Additional warning message shown in the Connect app platform warning banner when the tenant is enrolled in the Developer Canary Program. The Developer Canary Program and Forge changelog text are links to documentation where users can learn why the warning appears and watch release updates.',
	},
	dismiss: {
		id: 'connect-module-core.eos.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Action text for dismissing the Connect app platform warning message.',
	},
	inlineSecondaryText: {
		id: 'connect-module-core.eos.inlineSecondaryText',
		defaultMessage: 'This app might stop working soon',
		description: 'Short warning summary shown in the inline Connect app platform warning message.',
	},
});
